// Author Shi Wen Long
// Date 2024-06-03 09:49:12

import * as model from "@/model/sithMes/stool/SithMesStoolPoModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolPo(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'cpmFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'vendorFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'sithFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'cpmVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'vendorVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'sithVo'
    })
    .buildStore()
